import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

// Import existing winner components
import Winners from './Winners'; // 2024 Semifinalists
import WinnersTwo from './WinnersTwo'; // 2024 Finalists
import WinnersThree from './WinnersThree'; // 2024 Winners
import WinnersFour from './WinnersFour'; // 2025 Finalists
import WinnersFive from './WinnersFive'; // 2025 Winners
import Semifinalists from './Semifinals'; // 2025 Semifinalists
import DistinguishedScholar from './DistinguishedScholar'; // 2025 Distinguished Scholars
import OpensResultsAndHonorRollReleased from '../components/Opens-results-and-honor-roll-released'; // 2025 Honor Roll

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`winners-tabpanel-${index}`}
      aria-labelledby={`winners-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `winners-tab-${index}`,
    'aria-controls': `winners-tabpanel-${index}`,
  };
}

export default function WinnersHub() {
  const [value, setValue] = React.useState(0);

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ minHeight: '100vh', paddingBottom: '100px' }}>
      <div className="container">
        <div className='col' style={{paddingTop: "50px", paddingBottom: "30px"}}>
          <p 
            className="bigblueonthewing" 
            align="center"
            style={{ fontSize: "5ch", fontWeight: 500, marginBottom: '20px' }}
          >
            IRO Winners & Recognition
          </p>
          
          <Typography 
            variant="body1" 
            align="center" 
            style={{ maxWidth: '800px', margin: '0 auto', color: '#666' }}
          >
            Explore the achievements of outstanding students who have excelled in the International Research Olympiad. 
            Browse through winners, finalists, semi-finalists, and honor roll recipients from different years.
          </Typography>
        </div>

        <Box sx={{ width: '100%', marginTop: '40px' }}>
          <Stack direction="row" style={{ overflowX: 'auto' }} spacing={1}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', overflowX: 'auto', whiteSpace: 'nowrap' }}>
              <Tabs 
                value={value} 
                onChange={handleChange} 
                aria-label="IRO Winners tabs" 
                variant="scrollable" 
                scrollButtons="auto"
                sx={{
                  '& .MuiTab-root': {
                    textTransform: 'none',
                    fontSize: '16px',
                    fontWeight: 400,
                    color: 'black',
                    '&.Mui-selected': {
                      color: '#7d9ad4',
                      fontWeight: 500,
                    },
                  },
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#7d9ad4',
                  },
                }}
              >
                <Tab label="2025 Winners" {...a11yProps(0)} />
                <Tab label="2025 Finalists" {...a11yProps(1)} />
                <Tab label="2025 Semi-Finalists" {...a11yProps(2)} />
                <Tab label="2025 Distinguished Scholars" {...a11yProps(3)} />
                <Tab label="2025 Honor Roll" {...a11yProps(4)} />
                <Tab label="2024 Winners" {...a11yProps(5)} />
                <Tab label="2024 Finalists" {...a11yProps(6)} />
                <Tab label="2024 Semi-Finalists" {...a11yProps(7)} />
              </Tabs>
            </Box>
          </Stack>

          <CustomTabPanel value={value} index={0}>
            <WinnersFive />
          </CustomTabPanel>
          
          <CustomTabPanel value={value} index={1}>
            <WinnersFour />
          </CustomTabPanel>
          
          <CustomTabPanel value={value} index={2}>
            <Semifinalists />
          </CustomTabPanel>
          
          <CustomTabPanel value={value} index={3}>
            <DistinguishedScholar />
          </CustomTabPanel>
          
          <CustomTabPanel value={value} index={4}>
            <OpensResultsAndHonorRollReleased />
          </CustomTabPanel>
          
          <CustomTabPanel value={value} index={5}>
            <WinnersThree />
          </CustomTabPanel>
          
          <CustomTabPanel value={value} index={6}>
            <WinnersTwo />
          </CustomTabPanel>
          
          <CustomTabPanel value={value} index={7}>
            <Winners />
          </CustomTabPanel>
        </Box>
      </div>
    </div>
  );
}